var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"login-header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._v("pawaMatch")])]),_c('div',{staticClass:"dx-field"},[_c('dx-button',{attrs:{"styling-mode":"outlined","type":"default","text":"Login","width":"100%"},on:{"click":_vm.onLoginClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }